import { z } from 'zod';
/** Error payload returned by the API on any 4xx/5xx response. */
export const ApiErrorSchema = z.object({
    code: z.string(),
    message: z.string(),
    /** Structured, machine-readable error context (e.g. which fields are missing). */
    details: z.unknown().optional(),
});
/** Cursor-based pagination metadata included on paged success responses. */
export const PaginationMetaSchema = z.object({
    nextCursor: z.string().nullable(),
    hasNextPage: z.boolean(),
    /** Total number of matching records. Omitted for endpoints that do not compute a count. */
    total: z.number().int().optional(),
});
/** Failed response envelope — data and pagination are always null on errors. */
export const ApiFailureSchema = z.object({
    status: z.number().int(),
    data: z.null(),
    pagination: z.null(),
    error: ApiErrorSchema,
});
/**
 * Schema factory for ApiSuccess<T>. Provide the data schema to validate the full
 * envelope.
 *
 * Example:
 *
 * ```ts
 * const result = ApiSuccessSchema(HelloResponseSchema).safeParse(response)
 * ```
 */
export const ApiSuccessSchema = (dataSchema) => z.object({
    status: z.number().int(),
    data: dataSchema,
    pagination: z.null(),
    error: z.null(),
});
/**
 * Schema factory for ApiPagedSuccess<T>. Provide the item schema to validate the full
 * envelope.
 */
export const ApiPagedSuccessSchema = (itemSchema) => z.object({
    status: z.number().int(),
    data: z.array(itemSchema),
    pagination: PaginationMetaSchema,
    error: z.null(),
});
/**
 * Used by the backend ResponseInterceptor to detect paginated controller returns. Items
 * are typed as unknown because the controller's generic type is not available at
 * runtime.
 */
export const PagedResultBaseSchema = z.object({
    items: z.array(z.unknown()),
    nextCursor: z.string().nullable(),
    hasNextPage: z.boolean(),
    total: z.number().int().optional(),
});
//# sourceMappingURL=api.js.map